/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { env } from '$env/dynamic/public';
import type { AxiosRequestConfig } from 'axios';
import { axiosHandler } from "../axiosHandler";
import { datadogLogs } from '@datadog/browser-logs';

type ResponseData = {
    status: number,
    message: string
}

export const endConversation = async (requestData: {
    conversationId: string,
    brand: string,
    browser_uuid: string
}, token: string): Promise<ResponseData> => {
    const protocol = env.PUBLIC_NODE_ENV === 'dev' ? 'http://' : 'https://'
    const route = env.PUBLIC_NODE_ENV === 'dev' ? '/flora/end' : '/r/api/conversational/garden-webchat-api/flora/end'
    try {
        const config: AxiosRequestConfig = {
            method: 'POST',
            url: `${protocol}${env.PUBLIC_DOMAIN_URL}${route}`,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, },
            data: { conversationId: requestData.conversationId },
        };
        const response = await axiosHandler<ResponseData>(config);
        datadogLogs.logger.info(`[Conv-ui] Conversation Ended - brand: ${requestData.brand} browser_uuid: ${requestData.browser_uuid} conversation_id: ${requestData?.conversationId}`)
        return response?.data
    } catch (error) {
        datadogLogs.logger.error(`[Conv-ui] Conversation Ended Failure- brand: ${requestData.brand} browser_uuid: ${requestData.browser_uuid} error: ${error}`)

        console.log('error', error, requestData.conversationId)
        return {} as ResponseData
    }
}